/**
 * 작업 추가에서 **고를 수 있는 레시피** — `committed` 전부다(이름으로 거르지 않는다).
 * 🔴 eric 2026-10-29 「표준 시나리오 말고 다른 이름도 고를 수 있게 해줘. 레시피 템플릿이 아니라 레시피 추가하는 거야」 —
 *    10-14 의 «이름이 「CTCells 표준 시나리오」로 시작하는 것만»(`NEW_BATCH_RECIPE_PREFIX`)을 걷었다. 되살리지 마라.
 * 🔴 `committed` 만 — 서버 `committed_version()` 이 그 밖(작성 중 · 보관)을 422 로 떨어뜨린다. 차례는 받은 그대로다.
 */
export function newBatchRecipes<T extends { status: string }>(items: readonly T[]): T[] {
  return items.filter((recipe) => recipe.status === 'committed')
}
